/** @format */

import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import { InputOTP } from "antd-input-otp";

interface IProps {
	disableLogIn: boolean;
	onClickLogIn: () => void;
	otp: string [];
	onChangeOtp: (value: string []) => void;
}

const TwoFALoginFormView: React.FC<IProps> = (props) => {
	const [form] = Form.useForm();

	const handleSubmit = () => {
		props.onClickLogIn();
		props.onChangeOtp([]);
	};

	return (
		<Form form={form} onFinish={handleSubmit}>
			<Row>
				<Col >
					<Row>
						<Col style={{ width: "100%", textAlign: "center", marginBottom: "12px" }}>
							Enter One-Time Password (OTP):
						</Col>
					</Row>
					<Row>
						<Col style={{ width: "100%" }}>
							<Form.Item>
								<InputOTP
									onChange={(value) => props.onChangeOtp(value)}
									value={props.otp}
									inputType="numeric"
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row>
						<Col style={{ marginLeft: 'auto', marginRight: 'auto'}}>
							<Form.Item>
								<Button
									block
									disabled={props.disableLogIn}
									htmlType="submit"
									type="primary">
									Log in
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Form>
	);
};

export default TwoFALoginFormView;
